export default {
    "visible_auth_methods": [
        "loginPass"
    ],
    "auth_methods": {
        "loginPass": []
    }
}